const CheckboxInput = (props) => {
	const { children } = props;

	const inputProps = Object.assign({}, props);

	delete inputProps.children;

	if (props.onChange) {
		delete inputProps.defaultChecked;
		inputProps.onChange = (e) => props.onChange(e.target.checked);
		inputProps.checked = props.checked;
	}

	return (
		<label className="sui-checkbox">
			<input type="checkbox" {...inputProps} />
			<span aria-hidden="true" />
			{children && <span>{children}</span>}
		</label>
	);
};

export default CheckboxInput;
